export default __webpack_public_path__ + "static/media/CMC_logo_apaisado.5fa7f464.png";